import { useCountUp } from '../hooks/useCountUp';

function StatItem({ value, suffix, label, delay }) {
  const { ref, count } = useCountUp(value, 2200);
  return (
    <div ref={ref} className="text-center reveal" style={{ transitionDelay: delay }}>
      <p className="font-playfair italic text-5xl md:text-6xl text-sage font-light">
        {count.toLocaleString('pt-PT')}{suffix}
      </p>
      <p className="font-dm text-sm text-ink-light tracking-wide mt-3 uppercase">{label}</p>
    </div>
  );
}

export default function Stats() {
  return (
    <section className="py-24 bg-beige-light/40 border-y border-beige/40">
      <div className="max-w-5xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-12">
        <StatItem value={2400} suffix="+" label="Alunos" delay="0ms" />
        <StatItem value={12} suffix="" label="Instrutores" delay="100ms" />
        <StatItem value={8} suffix="" label="Anos de Experiência" delay="200ms" />
        <StatItem value={34} suffix="" label="Aulas por Semana" delay="300ms" />
      </div>
    </section>
  );
}
